import { render, staticRenderFns } from "./eventPie.vue?vue&type=template&id=b5f01d5e&scoped=true&"
import script from "./eventPie.vue?vue&type=script&lang=js&"
export * from "./eventPie.vue?vue&type=script&lang=js&"
import style0 from "./eventPie.vue?vue&type=style&index=0&id=b5f01d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f01d5e",
  null
  
)

export default component.exports